import React from "react";

const DownloadSection = () => {
  const downloadFiles = [
    {
      id: 2,
      name: "Annexure I – Details of Hospital (Own or Rented)",
      filename: "ApplicationForm.pdf", // Same as main form
      description: "Details of hospital property ownership",
    },
    {
      id: 3,
      name: "Annexure II – Certificate of Undertaking",
      filename: "Annexure-II.pdf",
      description: "Certificate of undertaking document",
    },
    {
      id: 4,
      name: "Annexure III – Terms & Conditions",
      filename: "Annexure-III.pdf",
      description: "Terms and conditions for empanelment",
    },
    {
      id: 5,
      name: "Annexure IV",
      filename: "Annexure-IV.pdf",
      description: "Additional annexure document",
    },
    {
      id: 6,
      name: "Certificate Template",
      filename: "Certificate.pdf",
      description: "Template for various certificates",
    },
  ];

  const handleDownload = (filename) => {
    const link = document.createElement("a");
    link.href = `/assets/${filename}`;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="download-section">
      <div className="download-notes">
        {downloadFiles.map((file, index) => (
          <div key={file.id} className="download-note-item">
            <span className="note-label">NOTE {index + 1}:</span>
            <span className="note-text">
              <a
                href={`/assets/${file.filename}`}
                download={file.filename}
                className="download-link"
                onClick={(e) => {
                  e.preventDefault();
                  handleDownload(file.filename);
                }}
              >
                Click Here
              </a>
              <span className="download-icon">📥</span>
              to download {file.filename}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DownloadSection;
